// [BD Feat] Js of Section for showing benefits lists in a slider view
(function () {
  function initBenefitsSlider(section) {
    var sectionId = section.dataset.sectionId;
    var carousel = section.querySelector('.benefits-wrapper');

    if (!carousel || carousel.flickityInstance) return;

    var computedContent = window.getComputedStyle(carousel, '::after').getPropertyValue('content');
    if (computedContent.includes('flickity')) {
      var flickityInstance = new Flickity(carousel, {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: true,
        watchCSS: false,
        prevNextButtons: false,
        draggable: true
      });
      carousel.flickityInstance = flickityInstance;
    }
  }

  function destroyBenefitsSlider(section) {
    var carousel = section.querySelector('.benefits-wrapper');
    if (carousel && carousel.flickityInstance) {
      carousel.flickityInstance.destroy();
      carousel.flickityInstance = null;
    }
  }

  function shouldEnableSlider(carousel) {
    var computedContent = window.getComputedStyle(carousel, '::after').getPropertyValue('content');
    return computedContent.includes('flickity');
  }

  function setupBenefitsSlider() {
    document.querySelectorAll('.benefits-list-section').forEach(function (section) {
      var carousel = section.querySelector('.benefits-wrapper');
      if (!carousel) return;

      const shouldBeEnabled = shouldEnableSlider(carousel);
      const isEnabled = !!carousel.flickityInstance;

      if (shouldBeEnabled && !isEnabled) {
        initBenefitsSlider(section);
      } else if (!shouldBeEnabled && isEnabled) {
        destroyBenefitsSlider(section);
      }
    });
  }

  // Wait until DOM is fully loaded
  document.addEventListener("DOMContentLoaded", function () {
    setupBenefitsSlider();

    // Re-init on resize (debounced)
    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setupBenefitsSlider, 300);
    });

    // Shopify Section Events
    document.addEventListener('shopify:section:load', function (event) {
      const section = document.querySelector('.benefits-list-section[data-section-id="' + event.detail.sectionId + '"]');
      if (section) {
        setTimeout(() => setupBenefitsSlider(), 500);
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      const section = document.querySelector('.benefits-list-section[data-section-id="' + event.detail.sectionId + '"]');
      if (section) {
        destroyBenefitsSlider(section);
      }
    });

    document.addEventListener('shopify:theme-settings:updated', setupBenefitsSlider);
  });
})();
